const menuItem = {
  list: [{
      id: 1,
      name: 'Lista Bambini',
    },
    {
      id: 2,
      name: 'Appello',
    },
    {
      id: 3,
      name: 'Bimbi in classe',
    },
    {
      id: 4,
      name: 'Menza',
    },
    {
      id: 5,
      name: 'Altre funzioni',
    },
  ],
};

export default menuItem;
